/**
 * Loading Spinner Component
 *
 * Animated spinner for loading states.
 */

import type { ReactElement } from "react";

type SpinnerSize = "sm" | "md" | "lg";

interface LoadingSpinnerProps {
  readonly size?: SpinnerSize;
  readonly className?: string;
}

const SIZE_CLASSES: Readonly<Record<SpinnerSize, string>> = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-10 w-10",
};

export function LoadingSpinner({ size = "md", className = "" }: LoadingSpinnerProps): ReactElement {
  return (
    <svg
      className={`animate-spin text-primary ${SIZE_CLASSES[size]} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="Loading"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
